/**
 *
 * @param {string} str
 * @param {string?} separator
 * @param {string?} equalizer
 * @returns {*}
 */
export default function reduceQueryToObject(str, separator = '&', equalizer = '=') {
  return (str || '').replace(/^\?/, '').split(separator).reduce((o, pairString) => {
    const pair = pairString.split(equalizer)
    o[pair[0]] = pair[1]
    return o
  }, {})
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/common/reduceQueryToObject.js